// src/components/public/PublicLayout.jsx
import React from 'react';
import PublicNavbar from './PublicNavbar';
import useAuth from '../../hooks/useAuth';
import { useLanguage } from '../../contexts/LanguageContext';

const PublicLayout = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { t } = useLanguage();
  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-neutral-50">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary-600 mx-auto"></div>
          <p className="text-center mt-4 text-neutral-600">Loading...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Public Navigation Bar */}
      <PublicNavbar />
      
      {/* Main Content */}
      <main className="flex-grow">
        {children}
      </main>
      
      {/* Footer */}
      <footer className="bg-primary-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="text-xl font-bold tracking-wide mb-4">
                <span className="bg-white text-primary-800 px-2 py-1 rounded">{t('companyNameShort')}</span>
              </div>
              <p className="text-primary-200 text-sm mt-2">
			  {t('servicesShortDesc')}
              </p>
            </div>
            
            <div>
              <h3 className="text-lg font-medium mb-4">{t('LayoutServices')}</h3>
              <ul className="space-y-2 text-primary-200">
                <li><a href="#" className="hover:text-white">{t('LayoutRegistration')}</a></li>
                <li><a href="#" className="hover:text-white">{t('LayoutInsurance')}</a></li>
                <li><a href="#" className="hover:text-white">{t('LayoutDocumentation')}</a></li>
                <li><a href="#" className="hover:text-white">{t('LayoutConsultation')}</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-medium mb-4">{t('LayoutSupport')}</h3>
              <ul className="space-y-2 text-primary-200">
                <li><a href="#" className="hover:text-white">{t('LayoutHelp')}</a></li>
                <li><a href="#" className="hover:text-white">{t('LayoutCont')}</a></li>
                <li><a href="#" className="hover:text-white">{t('LayoutFAQ')}</a></li>
                <li><a href="#" className="hover:text-white">{t('LayoutTerms')}</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-medium mb-4">{t('LayoutContact')}</h3>
              <address className="text-primary-200 not-italic">
                <p>{t('LayoutAddress1')}</p>
                <p>{t('LayoutAddress2')}</p>
                <p className="mt-3">info@tts.am</p>
                <p>  </p>
              </address>
            </div>
          </div>
          
          <div className="border-t border-primary-700 mt-8 pt-8 flex flex-col sm:flex-row justify-between">
            <p className="text-sm text-primary-300">
              &copy; {new Date().getFullYear()} TTS. All rights reserved.
            </p>
            <div className="mt-4 sm:mt-0">
              <ul className="flex space-x-4">
                <li><a href="#" className="text-primary-300 hover:text-white">{t('LayoutPrivacy')}</a></li>
                <li><a href="#" className="text-primary-300 hover:text-white">{t('LayoutTerm')}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;